export class AtoInterfacesIcons {
	public static requestStatus = {
		O: '<i class="fas fa-pause text-danger" aria-hidden="true"></i>',
		Q: '<i class="fas fa-sign-out-alt text-warning" aria-hidden="true"></i>',
		P: '<i class="fas fa-clock text-warning" aria-hidden="true"></i>',
		R: '<i class="fas fa-check text-success" aria-hidden="true"></i>',
		E: '<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>',
		J: '<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>',
		K: '<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>',
		C: '<i class="fas fa-ban text-warning" aria-hidden="true"></i>',
		S: '<i class="fas fa-clock text-warning" aria-hidden="true"></i>',
	};
}
